'use client';

import { useState } from 'react';

import { cn } from '@ui/lib/utils';

import StarBoldDecor from '../../../icons/StarBoldDecor';
import { StarRating } from '../starRating/StarRating';

export interface RateMentorCardProps {
  onWriteReview?: (rating: number) => void;
  className?: string;
  title?: string;
  subtitle?: string;
  ctaText?: string;
}

export const RateMentorCard = ({
  onWriteReview,
  className,
  title = 'How was your experience?',
  subtitle = 'Tell us about the mentor',
  ctaText = 'Write a Review'
}: RateMentorCardProps) => {
  const [selectedRating, setSelectedRating] = useState(0);

  return (
    <div className={cn('relative bg-primary-50 rounded-lg px-4 py-3 overflow-hidden flex flex-col gap-4', className)}>
      <StarBoldDecor className="absolute -left-6 -top-4.5 size-[100px] text-primary opacity-[0.13]" />

      <div className="flex flex-col gap-1 relative">
        <h4 className="text-base font-semibold text-neutral-800 leading-snug">{title}</h4>
        <p className="text-xs text-neutral-800 leading-normal">{subtitle}</p>
      </div>

      <StarRating
        value={selectedRating}
        onChange={(rating) => {
          setSelectedRating(rating);
          onWriteReview?.(rating);
        }}
        size="lg"
        emptyColor="text-primary/25"
        className="justify-around md:justify-start md:gap-4 [&_svg]:!size-11"
      />

      <button
        type="button"
        className="cursor-pointer self-start text-sm font-semibold text-primary hover:underline"
        onClick={() => onWriteReview?.(selectedRating)}
      >
        {ctaText}
      </button>
    </div>
  );
};
